import React, {useState} from 'react'

import Select from 'Components/Select'
import Input from 'Components/Input'
import Constants from 'EurestoFonction/Constants'
import Grid from '@material-ui/core/Grid'
import Title from 'Components/Title'
import Utils from 'EurestoFonction/Utils'

export default React.memo(props => {

  const [data, setData] = useState(props.data || [])
  const [key, setKey] = useState(Utils.getRandomNumber())

  const onClickAddComboMultiSaisieLibre = () => {
    let d = data || []
    if (data.reduce((a, b) => a && b.id && true, true)) {
      d.push({ id: undefined })
    }
    setData(d)
    setKey(Utils.getRandomNumber())
  }
  const onClickRemoveComboMultiSaisieLibre = (index) => {
    let d = data
    d.splice(index, 1)
    setData(d)
    setKey(Utils.getRandomNumber())
    props.onChange(d, props.name)
  }

  const onChangeComboMultiSaisieLibre = (e, index) => {
    let d = data
    d[index].id = e
    setData(d)
    setKey(Utils.getRandomNumber())
    props.onChange(d, props.name)
  }

  const onChangeSecondComboMultiSaisieLibre = (e, index) => {
    let d = data
    d[index].valeur_text = e
    setData(d)
    props.onChange(d, props.name)
  }

  return <Title key={key} inline={props.inline} style={{ padding: '5px 0' }}
                title={props.title}
                buttons={(props.comboMultipleOption(props.options)).length > 0 && !props.disabled &&
                data.reduce((a, b) => a && b.id && true, true) &&
                <button type="button" onClick={onClickAddComboMultiSaisieLibre}
                        className="text-success ei-commun_ajouter"
                        style={{ marginLeft: 5 }}/>}>
    {
      (data).map((data, index) => (
        <Grid container key={data.id + '_' + index} style={{ margin: 0, padding: 0 }} spacing={0} justify={'center'}
              alignItems={'center'}>
          {!props.disabled && <Grid item style={{ margin: 0, padding: 0, }}>
            <button type="button" onClick={() => onClickRemoveComboMultiSaisieLibre(index)}
                    className="text-danger ei-commun_enlever"/>
          </Grid>}
          <Grid item xs style={{ margin: 0, padding: 0 }}>
            <Select style={props.style}
                    disabled={props.disabled || false}
                    options={props.comboMultipleOption(props.options, data.id)}
                    onChange={onChangeComboMultiSaisieLibre}
                    name={index}
                    value={data.id}/>
          </Grid>
          <Grid item xs style={{ margin: 0, padding: 0 }}>
            <Input
              onChange={(e) => onChangeSecondComboMultiSaisieLibre(e, index)}
              name={'valeur_text'}
              disabled={props.disabled || false}
              value={data.valeur_text !== undefined ? data.valeur_text : ""}
            />
          </Grid>
        </Grid>
      ))
    }
  </Title>
})



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataComponent/Components/ComboMultiSaisieLibre.js